<app-page-header>
    {{ 'Team' }}
    <a *ngIf="dataTable.hasData"
       mat-fab extended disableRipple color="primary"
       [attr.aria-label]="routerAddButton.ariaLabel"
       [routerLink]="routerAddButton.route">
        <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
        {{ routerAddButton.label }}
    </a>
</app-page-header>

<app-table #dataTable
           class="pmc-team-table"
           [hasFilters]="false"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [sortingDataAccessor]="sortingDataAccessor"
           [type]="tableType"
           [rowSelectable]="true"
           (rowSelect)="goToTeamMember($event)"
           (loaded)="hasData = $event.data.length > 0"
           matSort
           matSortActive="name"
           matSortDirection="asc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="[row.id, 'details']" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.email }} | {{ getOrganizationsCount(row.memberships) | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="[row.id, 'details']" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ getOrganizationsCount(row.memberships) | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[2].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
            {{ row?.propertyManagementCompanyUser ? 'Property Manager' : 'Community Manager' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.email">
            {{ row.email }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[4].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.memberships[0].profile.phone">
            {{ row.memberships[0].profile.phone ? (row.memberships[0].profile.phone | legfiPhone) : '' }}
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'users'">
        <span emptyStateTitle>{{ 'No team members so far...' }}</span>
        <a mat-fab extended disableRipple color="primary"
           [attr.aria-label]="routerAddButton.ariaLabel"
           [routerLink]="routerAddButton.route">
            <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
            {{ routerAddButton.label }}
        </a>
    </app-empty-state>
</app-table>
